import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        const burger = document.querySelector('[data-burger="burger"]');
        const burgerClose = document.querySelector('[data-burger="close"]');
        this.el.addEventListener('click', () => {
            burger.classList.add('opened');
        });
        burgerClose.addEventListener('click', function () {
             burger.classList.remove('opened');
        });
    }
}
